/**
 * Initiation timestamp for device transfers.
 * Submitted transfers use requested_at; cancelled drafts (never submitted) use created_at.
 */
export const getTransferInitiationDate = (transfer) => {
  if (!transfer) return null;
  if (transfer.requested_at) return transfer.requested_at;
  if (transfer.status === 'cancelled') return transfer.created_at || null;
  return null;
};

export const getTransferInitiationDateLabel = (transfer) => {
  if (transfer?.requested_at) return 'Requested at';
  if (transfer?.status === 'cancelled' && transfer?.created_at) return 'Draft started at';
  return 'Requested at';
};

export const formatTransferDateTime = (value) => {
  if (!value) return null;
  try {
    return new Date(value).toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(value);
  }
};
